/**
 * @file popover.tsx
 * @description Popover-примитив на base-ui (phase08.5).
 */

import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import * as React from "react";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Trigger;

interface PopoverContentProps
  extends React.ComponentProps<typeof PopoverPrimitive.Popup> {
  align?: "start" | "center" | "end";
  sideOffset?: number;
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 8,
  children,
  ...props
}: PopoverContentProps) {
  return (
    <PopoverPrimitive.Portal>
      {/*
        Слой живёт на позиционере, а не на попапе: сам попап у base-ui
        `position: static`, и `z-index` на нём браузер игнорирует — поповер
        уезжал ПОД диалог (z-60) и список ячеек был некликабелен (дефект QA
        2026-09-21). Позиционер — `position: absolute` с transform, то есть
        собственный контекст наложения. Шкала слоёв — `--z-*` в `index.css`.
      */}
      <PopoverPrimitive.Positioner
        align={align}
        sideOffset={sideOffset}
        className="z-[var(--z-popover)]"
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          className={cn(
            "min-w-[8rem] rounded-lg bg-surface-lowest p-3 text-sm",
            "[box-shadow:0_8px_24px_var(--shadow-ambient),inset_0_0_0_1px_var(--outline-variant)]",
            "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
            "data-[ending-style]:scale-95 data-[starting-style]:scale-95",
            "transition-all duration-200 origin-[var(--transform-origin)]",
            className,
          )}
          {...props}
        >
          {children}
        </PopoverPrimitive.Popup>
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  );
}

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };
